<fui-multiselect-control [options]="data" [disabled]="readonly"
                         [labelField]="labelField"
                         [summaryLabelField]="summaryLabelField"
                         [placeholder]="placeholder"
                         [label]="label"
                         [loading]="isLoading"
                         [(value)]="selectControlValues"
                         [valueField]="valueField"
                         (focussed$)="onFocus($event)"
                         [control]="formControlValidation"
                         [internallyFilterable]="!customFiltering"
                         [total]="totalRecords"
                         (filtered$)="filtered($event)"
                         (extended$)="openExtendedSearch()"
                         (added$)="openAdd()"
                         (optionOpened$)="openView($event, true)"
                         [pillRemovable]="pillRemovable"
                         (removed$)="onRemove()"
                         [showSelections]="showSelections"
                         [showExtendedSearchOption]="extendedSearchComponent != undefined"
                         [showAddOption]="extendedEditComponent != undefined"
                         [showOptionOpenOption]="(extendedEditComponent != undefined || showOptionOpenOption) && !hideOptionOpenOption">
    <fui-content-section>
        <ng-content></ng-content>
    </fui-content-section>
</fui-multiselect-control>
